import Vue from "vue";
import Vuetify from "vuetify";
import lodash from "lodash";
import { VueReCaptcha } from "vue-recaptcha-v3";
import VueVirtualScroller from "vue-virtual-scroller";

import Toolbar from "@/components/common/Toolbar.vue";
import Card from "@/components/common/Cards.vue";
import CardCheckBox from "@/components/common/CardCheckBox.vue";
import DataTable from "@/components/common/DataTable.vue";
import Tabs from "@/components/common/Tabs.vue";
import Toggle from "@/components/common/ToggleButton.vue";
import CustomToggle from "@/components/common/CustomToggleButton.vue";
import SimpleList from "@/components/common/SimpleList.vue";
import Select from "@/components/common/Select.vue";
import Graph from "@/components/common/Graph.vue";
import GlobalGraph from "@/components/common/GlobalGraph";
import RecyclerDataTable from "@/components/common/RecyclerDataTable.vue";
import CopyrightFooter from "@/components/CopyrightFooter.vue";

import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@mdi/font/css/materialdesignicons.css";

import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import mqtt from "@/plugins/mqtt";
import i18n from "@/plugins/i18n";
import "./registerServiceWorker";

Vue.use(VueVirtualScroller);
Vue.component("Toolbar", Toolbar);
Vue.component("Card", Card);
Vue.component("CardCheckBox", CardCheckBox);
Vue.component("DataTable", DataTable);
Vue.component("Tabs", Tabs);
Vue.component("Toggle", Toggle);
Vue.component("CustomToggle", CustomToggle);
Vue.component("SimpleList", SimpleList);
Vue.component("Select", Select);
Vue.component("Graph", Graph);
Vue.component("GlobalGraph", GlobalGraph);
Vue.component("RecyclerDataTable", RecyclerDataTable);
Vue.component("CopyrightFooter", CopyrightFooter);

Vue.prototype.$bus = new Vue({});

Vue.use(lodash);
const vuetifyConfig = {
  iconfont: "mdi",
  theme: {
    bg: "#04112F",
    primary: "#000427",
    secondary: "#3D485D",
    tertiary: "#34656d",
    fourth: "#34656d",
    fifth: "#151d35",
    // active: '#f4a135',

    accent: "#E9952A",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107",
    green: "#7fff00",
    heat: "#f36615",
    black: "#3c3c3c",
    white: "#fff",
    grey: "#c2c2c2",
    number: "#668cf6",

    activeButton: "#2C3C6F",
    extraPurple: "#6868C9",
    extraYellow: "#ED982B",
    extraBlue: "#00BFA7",
    extraRed: "#FF6B7E",
    extraGreen: "#89DB50",
    extraGrey: "#D4D4D4",

    primaryText: "#FFF",
    secondaryText: "#6b6b6b",
    activeText: "#9fc03b",
    lightText: "#686B71",
    sixth: "#121a37",
    try: "#21E39B",
    blockCard: "#09152e",
    roomRow: "#122040",
    cardBorder: "#23355e",
  },
  options: {
    customProperties: true,
  },
};

Vue.use(Vuetify, vuetifyConfig);

Vue.config.productionTip = false;
Vue.use(mqtt);

Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true,
  },
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
